import { z } from 'zod';

/** BR-SO-165/166: display fields come from the client — it already has them loaded. */
export const ReceptionPdfBodySchema = z.object({
  workshopName: z.string().trim().min(1),
  partyName: z.string().trim().min(1),
  vehicleLabel: z.string().trim().min(1),
  vehiclePlate: z.string().trim().nullable(),
});

export type ReceptionPdfBody = z.infer<typeof ReceptionPdfBodySchema>;

export const ReceptionPdfUrlSchema = z.object({
  downloadUrl: z.string(),
  expiresAt: z.iso.datetime(),
  contentType: z.literal('application/pdf'),
  disposition: z.literal('inline'),
});

export type ReceptionPdfUrl = z.infer<typeof ReceptionPdfUrlSchema>;

export const ShareReceptionWhatsAppBodySchema = ReceptionPdfBodySchema.extend({
  toE164: z.string().trim().min(8).max(20),
});

export type ShareReceptionWhatsAppBody = z.infer<typeof ShareReceptionWhatsAppBodySchema>;

export const ShareReceptionWhatsAppResponseSchema = z.object({
  ok: z.boolean(),
});

export type ShareReceptionWhatsAppResponse = z.infer<typeof ShareReceptionWhatsAppResponseSchema>;
